import React, { useEffect, useState } from 'react';
import { Input, Button, Divider, Row, Col } from 'antd';
import { useTranslation } from 'react-i18next';
import { FiPlusCircle } from "react-icons/fi";
import { useNavigate } from 'react-router-dom';
import { deleteDataRequest, getDataRequest, postDataRequest } from '../../api/serviceMethods';
import { PRODUCT_CATEGORY_URL } from '../../api/URLs';
import SearchSvg from '../../assets/images/SearchSvg';
import SelectComponent from '../../components/select/SelectComponent';
import ProductCategoryModal from '../../components/magazine/ProductCategoryModal';

const BannerHeader = ({
    setModalOpen, modalOpen,
    loading, setTableParams, setLoading,
    tableParams, initLoadProduct,
    setKeyword, keyword, messageModalRef,
    dataObject, setDataObject
}) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [newTag, setNewTag] = useState("");
    const [tags, setTags] = useState([
        { label: "技术与教育", value: "技术与教育" },
        { label: "产品", value: "产品" },
    ]);
    const [loadingNew, setLoadingNew] = useState(false);

    return (
        <>
            <Row className='d-flex align-items-center mt-4'>
                <Col md={7}>
                    <SelectComponent
                        width="300px"
                        options={tags?.map(t => ({
                            label: t.label,
                            value: t.value,
                        }))}
                        value={dataObject?.type}
                        setValue={(value) => setDataObject({ ...dataObject, type: value })}
                        placeholder={t("Type")}
                        disabled={loading}
                    />
                </Col>
                <Col md={17} style={{ display: 'flex', alignItems: 'center', justifyContent: "space-between" }}>
                    <Button
                        size="large"
                        onClick={() => {
                            setTableParams({
                                ...tableParams,
                                pagination: {
                                    ...tableParams.pagination,
                                    current: 1,
                                },
                            });
                            initLoadProduct();
                        }}
                    >
                        {t('Query')}
                    </Button>
                    <Divider type="vertical" style={{ height: '24px', borderColor: '#d9d9d9' }} />
                    <div className='d-flex align-items-center'>
                        <Button
                            icon={<FiPlusCircle />}
                            onClick={() => navigate("/create/banner")}
                            style={{
                                fontSize: '16px',
                                backgroundColor: "#F8E2E8",
                                border: "none",
                                color: "#E50A47"
                            }}
                            danger
                        >
                            {t('Create Banner')}
                        </Button>
                    </div>
                </Col>
            </Row>
        </>
    );
};

export default BannerHeader;
